window["ThemeTile"] = (link, title) => {
  return {
    link: link,
    title: title,
    async openQuickView() {
      this.$store.quickview.render(link);
      this.$store.modals.open("productQuickView");
    },
  };
};
